import { HomeStoryBehind } from './HomeStoryBehind';
import { useInView } from 'react-intersection-observer';
import '../styles/StoryBehindAlnair.scss';

function StoryBehindAlnair(props: { title: string }) {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });
  return (
    <div className="story-behindAlnair-page-wrapper">
      <div
        ref={ref}
        className={
          inView ? 'story-behindAlnair slideInUp' : 'story-behindAlnair'
        }
      >
        <div className="section-shadow section-shadow-from-top"></div>
        <div className="title-wrapper">
          <h1 className="future-title">Story Behind Alnair</h1>
          <div className="description">
            These highlights from Alnair’s 2022 debut mark the beginning of our journey — while we’re building an exciting new version with advanced technology, here’s where it all started.
          </div>
        </div>
        <div className="section-shadow section-shadow-from-bottom"></div>
        <HomeStoryBehind />
      </div>
    </div>
  );
}

export default StoryBehindAlnair;
